module.exports = __webpack_public_path__ + "img/FacebookPurple.01ad4acf.svg";